import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
    static targets = ["input"]

    open() {
        try {
            this.inputTarget.showPicker()
        } catch (error) {
            this.inputTarget.click()
        }
    }

    jump(event) {
        const selectedDate = this.inputTarget.value
        if (!selectedDate) return

        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)
        params.set("date", selectedDate)
        url.search = params.toString()

        if (window.Turbo) {
            window.Turbo.visit(url.toString(), { action: "advance" })
        } else {
            window.location.href = url.toString()
        }
    }
}
